export default __webpack_public_path__ + "static/media/1.3810b511.png";